// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__11tyh","textarea":"styles_textarea__iMJiI"};